/* caleums-events.js — Caleums funnel UI-intent tracer (CEL-14).
 * Emits UI-intent events + a lightweight add_to_cart (product-handle only). Precise
 * commerce/revenue truth (variant, value, checkout) stays with the Shopify Web Pixel (CEL-11).
 * Envelope (theme_role, qa_run_id, page_type, viewport) is registered as PostHog
 * super-properties on init so $pageview carries it too. theme_role/page_type come
 * from data-* attributes on <html> set by Liquid (theme.role == 'main' ? 'live' : 'staging').
 * Click events (delegated via onClick): product_card_click, hero_cta_click, nav_category_click,
 * whatsapp_consult_click. cart_drawer_opened uses risingEdge() + a MutationObserver on the cart
 * drawer element (wired in init once the drawer selector/open-predicate are set).
 * Listener is bound once at document level (dedup guard on
 * window) so it survives Prestige Section-Rendering re-renders without double-firing. */
(function (root, factory) {
  var api = factory();
  if (typeof module !== "undefined" && module.exports) {
    module.exports = api; // test harness
  } else {
    api.autoInit(root); // browser
  }
})(typeof self !== "undefined" ? self : this, function () {
  function createTracker(env) {
    var doc = env.document;
    var root = doc.documentElement;

    function themeRole() {
      return root.getAttribute("data-caleums-theme-role") || "live";
    }
    function pageType() {
      return root.getAttribute("data-caleums-page-type") || "unknown";
    }
    function viewport() {
      return (env.window.innerWidth || 1440) < 768 ? "mobile" : "desktop";
    }
    function qaRunId() {
      try {
        var v = env.localStorage.getItem("caleums_qa_run_id");
        if (v) return v;
      } catch (e) {}
      var m = /[?&]qa_run_id=([^&]+)/.exec(env.location.search || "");
      return m ? decodeURIComponent(m[1]) : undefined;
    }
    function envelope() {
      return {
        theme_role: themeRole(),
        qa_run_id: qaRunId(),
        page_type: pageType(),
        viewport: viewport(),
      };
    }

    function capture(event, props) {
      var ph = env.window.posthog;
      if (!ph) return;
      ph.capture(event, props);
    }

    function onClick(e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var card = t.closest("[data-caleums-card]");
      if (card) {
        capture("product_card_click", {
          collection: card.dataset.collection,
          position: Number(card.dataset.position),
        });
        return;
      }
      var hero = t.closest("[data-caleums-hero-cta]");
      if (hero) {
        capture("hero_cta_click", { cta: hero.dataset.cta });
        return;
      }
      var nav = t.closest("[data-caleums-nav]");
      if (nav) {
        capture("nav_category_click", { category: nav.dataset.category });
        return;
      }
      var wa = t.closest("[data-caleums-whatsapp]");
      if (wa) {
        capture("whatsapp_consult_click", {});
        return;
      }
      var atc = t.closest("[data-caleums-atc]");
      if (atc) {
        // Product handle is correct regardless of the selected variant; precise
        // per-variant/revenue truth comes from the Shopify Web Pixel (CEL-11).
        capture("add_to_cart", { product: atc.dataset.product });
        return;
      }
    }

    return {
      init: function () {
        var ph = env.window.posthog;
        if (!ph) return;
        ph.register(envelope());
        if (!env.window.__caleumsEventsBound) {
          env.window.__caleumsEventsBound = true;
          doc.addEventListener("click", onClick);
          watchCartDrawer();
        }
      },
    };

    function watchCartDrawer() {
      // Prestige's <cart-drawer id="cart-drawer"> toggles the `open` attribute on show/hide;
      // the host element is stable across the drawer's Section-Rendering child swaps.
      var drawer = doc.getElementById && doc.getElementById("cart-drawer");
      var MO = env.window.MutationObserver;
      if (!drawer || !MO) return;
      var edge = risingEdge(function () {
        capture("cart_drawer_opened", {});
      });
      edge(drawer.hasAttribute("open"));
      new MO(function () {
        edge(drawer.hasAttribute("open"));
      }).observe(drawer, { attributes: true, attributeFilter: ["open"] });
    }
  }
  function autoInit(win) {
    if (!win || !win.document) return;
    createTracker({
      window: win,
      document: win.document,
      localStorage: win.localStorage,
      location: win.location,
    }).init();
  }
  function risingEdge(fire) {
    var was = false;
    return function (isOpen) {
      if (isOpen && !was) fire();
      was = isOpen;
    };
  }
  return { createTracker: createTracker, autoInit: autoInit, risingEdge: risingEdge };
});
